module.exports = __webpack_public_path__ + "img/logo_new.4e5692d4.png";